import axiosWrapper from '@/utils/request'

const getAckInvoices = (accountId, params) => {
  return axiosWrapper({
    url: `/v1/business/importers/${accountId}`,
    params
  })
}

const fetchInvoiceStageCounters = (accountId) => {
  return axiosWrapper({
    url: `/v1/business/importers/${accountId}/view/invoices_stage_counters`
  })
}

export default {
  fetchInvoiceStageCounters,
  getAckInvoices
}
